
export default function Hero() {
  return (
    <section className="relative pt-32 pb-24 px-6 lg:px-12 overflow-hidden bg-[#FAFAF9]">
      <div className="max-w-7xl mx-auto relative z-10">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left Content Zone */}
          <div className="space-y-8">
            <h1 className="text-5xl lg:text-6xl font-bold leading-[1.1] tracking-tight">
              <span className="text-gray-900">Close diabetic eye exam care gaps&nbsp;</span>
              <span className="text-primary italic font-serif">at scale.</span>
            </h1>
            
            <p className="text-lg text-gray-600 leading-relaxed">
              Kinra Health deploys handheld, AI-enabled retinal screening in point-of-care settings and through mobile teams to raise screening rates for at-risk populations and improve performance on Medicare Advantage Stars, HEDIS, and value-based quality programs.
            </p>

            <div className="flex flex-wrap gap-4">
              <a
                href="#contact"
                className="bg-primary text-white px-8 py-4 rounded-full hover:bg-primary-dark transition-all hover:shadow-lg cursor-pointer whitespace-nowrap inline-flex items-center gap-2 group font-semibold"
              >
                <span>Request a Demo</span>
                <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
              </a>
              <a
                href="#contact"
                className="border-2 border-gray-900 text-gray-900 px-8 py-4 rounded-full hover:bg-gray-900 hover:text-white transition-all cursor-pointer whitespace-nowrap font-semibold"
              >
                Talk to an Expert
              </a>
            </div>

            {/* Proof Chips */}
            <div className="flex flex-wrap gap-3 pt-4">
              <div className="inline-flex items-center gap-2 bg-white px-4 py-2 rounded-full shadow-sm border border-gray-200">
                <i className="ri-hospital-line text-primary"></i>
                <span className="text-sm font-medium text-gray-700">Point-of-care + mobile screening</span>
              </div>
              <div className="inline-flex items-center gap-2 bg-white px-4 py-2 rounded-full shadow-sm border border-gray-200">
                <i className="ri-check-line text-primary"></i>
                <span className="text-sm font-medium text-gray-700">Minimal clinic lift</span>
              </div>
              <div className="inline-flex items-center gap-2 bg-white px-4 py-2 rounded-full shadow-sm border border-gray-200">
                <i className="ri-file-list-line text-primary"></i>
                <span className="text-sm font-medium text-gray-700">Results routing + documentation</span>
              </div>
              <div className="inline-flex items-center gap-2 bg-white px-4 py-2 rounded-full shadow-sm border border-gray-200">
                <i className="ri-bar-chart-line text-primary"></i>
                <span className="text-sm font-medium text-gray-700">Quality-measure reporting support</span>
              </div>
              <div className="inline-flex items-center gap-2 bg-white px-4 py-2 rounded-full shadow-sm border border-gray-200">
                <i className="ri-hand-coin-line text-primary"></i>
                <span className="text-sm font-medium text-gray-700">Risk-sharing options</span>
              </div>
            </div>
          </div>

          {/* Right Visual Zone */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl bg-white/10 backdrop-blur-sm">
              <div className="aspect-video">
                <iframe
                  src="https://www.youtube.com/embed/Mqa9FEJl4lg?autoplay=1&mute=1&loop=1&playlist=Mqa9FEJl4lg&controls=0&modestbranding=1&rel=0&showinfo=0&iv_load_policy=3&disablekb=1&fs=0&cc_load_policy=0&playsinline=1&enablejsapi=0&origin=https://readdy.ai&widget_referrer=https://readdy.ai"
                  className="w-full h-full"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  title="Kinra Health Demo"
                  style={{ pointerEvents: 'none' }}
                ></iframe>
                {/* Overlay to prevent interaction */}
                <div 
                  className="absolute inset-0 bg-transparent"
                  style={{ pointerEvents: 'auto' }}
                  onMouseEnter={(e) => e.preventDefault()}
                  onMouseOver={(e) => e.preventDefault()}
                ></div>
              </div>
            </div>

            {/* Floating Stats Card */}
            <div className="absolute -bottom-6 -left-6 bg-white rounded-2xl shadow-xl p-6 transform hover:scale-105 transition-transform">
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 bg-primary/20 rounded-full flex items-center justify-center">
                  <i className="ri-eye-line text-primary text-2xl"></i>
                </div>
                <div>
                  <div className="text-3xl font-bold text-gray-900">98%</div>
                  <div className="text-sm text-gray-600 font-medium">Screening Accuracy</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
